import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapFooter = React.lazy(function () {
    return import('../../bootstrap-components/components/BTFooter');
});
var bootStrapFooter = function (props) {
    return (React.createElement(BootStrapFooter, __assign({}, props)));
};
export var Footer = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapFooter(props);
        default:
            componentToDisplay = bootStrapFooter(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Footer.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'dark'
};
//# sourceMappingURL=Footer.js.map